<template>
  <div>
    <v-container fluid>
      <!-- <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("_ChatLogs")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader> -->
      <h2 class="heading-text">Chat Logs</h2>
      <div class="mt-2 mb-4">
        <hr />
      </div>

      <v-card class="card2" style="margin-top: 1rem">
        <div class="d-flex align-center gap-2">
          <img src="@/assets/material-symbols_arrow-range-rounded.svg" alt="img" width="20" height="20">
          <p class="card-title">{{ $t('dateRange') }}</p>
        </div>
        <!-- Main Filter Row -->
        <v-row class="items-center mt-2">
          <!-- Start Date -->
          <v-col cols="12" sm="6">
            <v-row>
              <v-col cols="5.5">
                <div class="mb-1 d-flex align-center" style="gap: 2px">
                  <label for="Start Date" class="text-sm font-medium text-gray-700">
                    Start Date
                  </label>
                  <v-tooltip location="top" max-width="230px">
                    <template v-slot:activator="{ props }">
                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                        style="cursor: pointer; margin-left: 4px;" />
                    </template>
                    <span>Select start date for filtering.</span>
                  </v-tooltip>
                </div>
                <v-menu v-model="startDateFlag" :close-on-content-click="false" transition="scale-transition"
                  location="bottom" min-width="auto">
                  <template #activator="{ props }">
                    <v-text-field v-model="startDate" readonly variant="plain" v-bind="props" density="compact"
                      color="grey" class="date-style">
                      <template #prepend-inner>
                        <img src="@/assets/lets-icons_date-range-duotone.svg" alt="img" width="20" height="20"
                          style="margin-left: 6px;" />
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="startDate"
                    @update:model-value="val => { startDate = formatDate(val); startDateFlag = false }"
                    color="red"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="1">
                <div class="date-divider-style">
                  <div class="date-divider">-</div>
                </div>
              </v-col>
              <v-col cols="5.5">
                <div class="mb-1 d-flex align-center" style="gap: 2px">
                  <label for="End Date" class="text-sm font-medium text-gray-700">
                    End Date
                  </label>
                  <v-tooltip location="top" max-width="230px">
                    <template v-slot:activator="{ props }">
                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                        style="cursor: pointer; margin-left: 4px;" />
                    </template>
                    <span>Select end date for filtering.</span>
                  </v-tooltip>
                </div>
                <v-menu v-model="endDateFlag" :close-on-content-click="false" transition="scale-transition"
                  location="bottom" min-width="auto">
                  <template #activator="{ props }">
                    <v-text-field v-model="endDate" readonly variant="plain" v-bind="props" density="compact"
                      color="grey" class="date-style">
                      <template #prepend-inner>
                        <img src="@/assets/lets-icons_date-range-duotone.svg" alt="img" width="20" height="20"
                          style="margin-left: 6px;" />
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="endDate"
                    @update:model-value="val => { endDate = formatDate(val); endDateFlag = false }"
                    color="red"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>





          <!-- Log Type -->
          <v-col cols="12" sm="3">
            <v-row>
              <v-col cols="11">
                <div class="mb-1 d-flex align-center" style="gap: 2px">
                  <label for="Log Type" class="text-sm font-medium text-gray-700">
                    Log Type
                  </label>
                  <v-tooltip location="top" max-width="346px">
                    <template v-slot:activator="{ props }">
                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                        style="cursor: pointer; margin-left: 4px;" />
                    </template>
                    <!-- <span>{{ $t('_InfoTypeOptions') }}</span> -->
                    <ul class="ml-3">
                      <li>Token Usage : Checking the number of tokens used.</li>
                      <li>Raw Log : All logs.</li>
                      <li>Memory Debugger : Memory data stored in each question and answer session.</li>
                    </ul>
                  </v-tooltip>
                </div>
                <v-select :items="type_options" item-title="name" item-value="value" placeholder="Choose Type"
                  persistent-placeholder variant="plain" density="compact" color="primary" v-model="type"
                  hide-details="auto" class="logType-select-input" style="padding: 0 8px;">
                  <v-tooltip location="top" max-width="300">
                    <span>{{ $t('_logTypeOptions') }}</span>
                  </v-tooltip>
                </v-select>
              </v-col>
              <v-col cols="1">
                <div class="mt-7">
                  <button type="button" @click="Search" class="search-btn">
                    <img src="@/assets/search.svg" alt="img" width="18" height="18" style="margin-top: 6px;">
                  </button>
                </div>
              </v-col>
            </v-row>


          </v-col>

          <div class="date-divider-style">
            <div class="action-divider"></div>
          </div>
          <!-- Advance Filters -->
          <v-col cols="12" sm="2">
            <div class="advance-filters">

              <img src="@/assets/cuida_filter-outline.svg" alt="img" width="22" height="22" />
              <span style="color: #C32E0E; font-size: 16px;">Advance Filters</span>
              <v-switch v-model="detailsExpanded" class="memory-switch" hide-details></v-switch>
            </div>
          </v-col>

          <!-- Filters Section -->
          <!-- <v-col cols="12" md="6">
            <div class="filter-section">
              <h4 class="section-title mb-3">
                <v-icon class="mr-2" color="primary" size="20">mdi-filter-cog</v-icon>
                {{ $t('Filters') }}
              </h4>
              <v-row>
                <v-col cols="12">
                  <v-card variant="outlined" class="filter-card">
                    <v-card-text class="pa-3">
                      <v-autocomplete 
                        label="Log Type" 
                        :items="type_options" 
                        item-title="name" 
                        item-value="value" 
                        clearable 
                        variant="outlined" 
                        v-model="type" 
                        density="compact"
                        color="primary"
                        prepend-inner-icon="mdi-filter-variant"
                      >
                        <template #append-inner>
                          <v-tooltip location="top" max-width="300">
                            <template #activator="{ props }">
                              <v-icon size="small" color="grey-darken-1" v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t('_InfoTypeOptions') }}</span>
                          </v-tooltip>
                        </template>
                      </v-autocomplete>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-col> -->
        </v-row>

        <v-card v-if="detailsExpanded" class="advanced-filter-card mt-8 pa-4">
          <div class="d-flex align-center gap-2">
            <img src="@/assets/cuida_filter-outline.svg" alt="img" width="20" height="20" />
            <p class="card-title">{{ $t("AdvancedFilters") }}</p>
          </div>
          <v-row class="mt-2">
            <v-col cols="12" sm="6" md="4">
              <div class="mb-1 d-flex align-center" style="gap: 2px">
                <label for="User Channel" class="text-sm font-medium text-gray-700">
                  User Channel
                </label>
                <v-tooltip location="top" max-width="320px">
                  <template v-slot:activator="{ props }">
                    <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                      style="cursor: pointer; margin-left: 4px;" />
                  </template>
                  <span>Enter the specific user ID or username that uniquely identifies this individual across all
                    chats.</span>
                </v-tooltip>
              </div>
              <v-text-field v-model="userChannel" placeholder="Enter User Channel" clearable variant="plain"
                density="compact" color="grey" class="date-style" style="padding: 0 8px;" />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <div class="mb-1 d-flex align-center" style="gap: 2px">
                <label for="Session ID" class="text-sm font-medium text-gray-700">
                  Session ID
                </label>
                <v-tooltip location="top" max-width="320px">
                  <template v-slot:activator="{ props }">
                    <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18"
                      style="cursor: pointer; margin-left: 4px;" />
                  </template>
                  <span>A unique ID that helps identify this chat session.</span>
                </v-tooltip>
              </div>
              <v-text-field v-model="sessionID" placeholder="Enter Session ID" clearable variant="plain"
                density="compact" color="grey" class="date-style" style="padding: 0 8px;" />
            </v-col>

            <v-col cols="12" sm="3" md="2" class="mt-7">
              <button class="download-btn">
                <span style="color: #ffffff; font-size: 14px;">Apply Filter</span>
              </button>
            </v-col>

            <v-col cols="12" sm="3" md="2">
              <button type="button" @click="userChannel = null; sessionID = null;" class="clear-button">
                <img src="@/assets/charm_cross.svg" alt="img" width="22" height="22" />
                <span class="filter-by">{{ $t("ClearFilters") }}</span>
              </button>
            </v-col>
          </v-row>
        </v-card>
      </v-card>

      <!-- Advanced Filters Panel -->
      <!-- <v-expansion-panels variant="accordion" class="mb-4">
            <v-expansion-panel>
              <v-expansion-panel-title @click="filterClick" class="filter-panel-title">
                <div class="d-flex align-center">
                  <v-icon class="mr-2" color="primary">mdi-filter-cog</v-icon>
                  <span class="font-weight-medium">{{ $t("AdvancedFilters") }}</span>
                </div>
                <template #actions="{ expanded }">
                  <v-icon :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'" color="primary"></v-icon>
                </template>
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-card variant="outlined" class="advanced-filter-card">
                  <v-card-text class="pa-4">
                    <v-row class="mt-2">
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                          label="User Channel" 
                          v-model="userChannel" 
                          clearable 
                          variant="outlined" 
                          density="compact"
                          prepend-inner-icon="mdi-account"
                          color="primary"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                          label="Session ID" 
                          v-model="sessionID" 
                          clearable 
                          variant="outlined" 
                          density="compact"
                          prepend-inner-icon="mdi-identifier"
                          color="primary"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" class="d-flex align-center">
                        <v-btn 
                          color="warning" 
                          variant="outlined" 
                          prepend-icon="mdi-refresh"
                          @click="userChannel = null; sessionID = null;"
                        >
                          {{ $t("ClearFilters") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels> -->

      <!-- Action Buttons Row -->
      <div class="action-row">
        <div class="d-flex align-center">
          <v-menu location="bottom">
            <template #activator="{ props }">
              <button class="download-btn" v-bind="props">
                <img src="@/assets/bxs_download.svg" alt="img" width="20" height="20" />
                <span style="color: #ffffff; font-size: 14px;">{{ $t('Download') }}</span>
              </button>
            </template>
            <v-list class="download-menu">
              <div @click="GetExportLog()" class="download-list-item mt-4">
                <img src="@/assets/tabler_message-down.svg" alt="img" width="20" height="20" />
                <span style="font-size: 14px;">Export Log Message</span>
              </div>
              <div @click="GetExportLogMonitoring()" class="download-list-item mt-4">
                <img src="@/assets/lucide_monitor-up.svg" alt="img" width="20" height="20" />
                <span style="font-size: 14px;">Export Log Monitoring</span>
              </div>
              <div @click="dialogExportQS = true; GetDDValidationPositive();" class="download-list-item mt-4">
                <img src="@/assets/uil_file-question.svg" alt="img" width="20" height="20" />
                <span style="font-size: 14px;">Export to Question Set</span>
              </div>
            </v-list>
          </v-menu>
        </div>
        <div class="d-flex justify-start align-center ga-6 mr-6">
          <span style="font-weight: 600; color: #171717; font-size: 16px;">Show All Text</span>
          <v-switch class="memory-switch" hide-details v-model="CheckboxShowAllText" />
        </div>
      </div>

      <!-- <v-row class="mt-4">
            <v-col cols="12">
              <v-card variant="outlined" class="action-card">
                <v-card-text class="pa-4">
                  <div class="d-flex justify-space-between align-center flex-wrap ga-3">
                    Left Side - Search Button
                    <div class="action-group">
                      <v-btn 
                        color="primary" 
                        variant="elevated" 
                        size="large" 
                        @click="Search"
                        class="search-btn"
                        prepend-icon="mdi-magnify"
                      >
                        {{ $t('search') }}
                      </v-btn>
                    </div>

                    Right Side - Download and Toggle
                    <div class="action-group d-flex align-center ga-3">
                      Download Menu
                      <v-menu location="bottom">
                        <template #activator="{ props }">
                          <v-btn
                            color="success"
                            variant="elevated"
                            v-bind="props"
                            prepend-icon="mdi-download"
                            class="download-btn"
                          >
                            {{ $t('Download') }}
                          </v-btn>
                        </template>
                        <v-list class="download-menu">
                          <v-list-item @click="GetExportLog()" prepend-icon="mdi-file-excel">
                            <v-list-item-title>Export Log Message</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="GetExportLogMonitoring()" prepend-icon="mdi-monitor">
                            <v-list-item-title>Export Log Monitoring</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            @click="dialogExportQS = true; GetDDValidationPositive();"
                            prepend-icon="mdi-help-circle"
                          >
                            <v-list-item-title>Export to Question Set</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      
                      Show All Text Toggle
                      <v-card variant="outlined" class="toggle-card">
                        <v-card-text class="pa-3">
                          <v-switch
                            v-model="CheckboxShowAllText"
                            :label="`${$t('_ShowAllText')}: ${CheckboxShowAllText ? $t('_ShowAllTextOn') : $t('_ShowAllTextOff')}`"
                            color="primary"
                            hide-details
                            density="compact"
                            inset
                          ></v-switch>
                        </v-card-text>
                      </v-card>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row> -->


      <!-- Data Table with Modern Styling -->
      <v-card class="data-table-card mt-6">
        <v-card-text>
          <h2 style="font-weight: 600; color: #171717;">Log Data</h2>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          :items="dataTable"
          :headers="headers"
          :loading="tableLoading"
          class="pa-4"
          >
          <!-- :items-per-page-options="[10, 25, 50, 100]" -->
          <!-- <template #top>
            <v-toolbar flat color="grey-lighten-4" class="table-toolbar">
              <v-toolbar-title class="text-h6 font-weight-medium">
                <v-icon class="mr-2" color="primary">mdi-table</v-icon>
                Log Data ({{ searchTotalTable }} records)
              </v-toolbar-title>
            </v-toolbar>
          </template> -->

          <template #no-data>
            <div class="d-flex justify-center align-center fixed" style="width: 100%">
              <span style="color: #646464; font-weight: 400;">No Data Available</span>
            </div>
          </template>

          <template #item="{ item }">
            <tr class="table-row">
              <td style="text-align: left">
                {{ item.number }}
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']"
                    v-html="substringLong(item.text)"></span>
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']"
                    v-html="substringLong(item.replymsg)"></span>
                  <v-tooltip location="top" max-width="230px">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" @click="item.show = !item.show" size="small" variant="text"
                        :icon="item.show ? 'mdi-chevron-up' : 'mdi-chevron-down'" color="primary"></v-btn>
                    </template>
                    <span>See More</span>
                  </v-tooltip>
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']"
                    v-html="substringLong(item.prompt)"></span>
                  <v-tooltip location="top" max-width="230px">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" @click="item.show = !item.show" size="small" variant="text"
                        :icon="item.show ? 'mdi-chevron-up' : 'mdi-chevron-down'" color="primary"></v-btn>
                    </template>
                    <span>See More</span>
                  </v-tooltip>
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']"
                    v-html="substringLong(item.vectorContext)"></span>
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  {{ substringLong(item.id) }}
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <v-chip size="small" variant="outlined">{{ substringLong(item.sessionID) }}</v-chip>
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']"
                    v-html="substringLong(item.modelDisplay)"></span>
                </div>
              </td>
              <td style="text-align: left">
                <div class="text-container">
                  <span :class="[item.show ? 'text-content-show' : 'text-content']"
                    v-html="substringLong(item.modelName)"></span>
                </div>
              </td>
              <td style="text-align: left">
                <v-chip size="small" :color="item.userChannel ? 'primary' : 'grey'" variant="outlined">
                  {{ item.userChannel ?? '-' }}
                </v-chip>
              </td>
              <td style="text-align: left">{{ item.createDate ?? '-' }}</td>
              <td style="text-align: left">
                <v-chip size="small" color="success" variant="outlined">{{ item.responseTimeStr }}</v-chip>
              </td>
            </tr>
          </template>

          <template v-slot:bottom>
            <div class="table-bottom-group">
              <div class="table-container">
              </div>
              <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                <div>Total results {{ searchTotalTable }}</div>

                <v-data-table-footer :items="[
                  { text: '10', value: 10 },
                  { text: '25', value: 25 },
                  { text: '50', value: 50 },
                  { text: '100', value: 100 },
                  { text: 'All', value: -1 },
                ]" :page="options.page" :length="Math.ceil(searchTotalTable / itemsPerPage)" />
              </div>
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>

    <v-dialog v-model="dialogExportQS" max-width="700" persistent>
      <v-card class="question-dialog" elevation="0">
        <div class="question-header">
          <h3 class="question-title">Export log to Question Set</h3>
          <button type="button" @click="dialogExportQS = false" class="mt-2">
            <img src="@/assets/codex_cross.svg" alt="close" width="30" height="30" />
          </button>
        </div>
        <hr>
        <v-card-text>
          <div class="d-flex justify-start align-center gap-2">
            <img src="@/assets/mdi_information-variant-box.svg" alt="img" width="20" height="20">
            <p style="color: #171717; font-size: 18px;">Information</p>
          </div>
          <v-row class="mt-2" align="end">
            <v-col cols="12" sm="9">
              <v-card class="pa-4">
                <v-row>
                  <v-col cols="12" sm="6">
                    <span>StartDate : <span class="modal-info">{{ startDate }}</span></span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <span>User Channel : <span class="modal-info">{{ userChannel ?? '-' }}</span></span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <span>EndDate : <span class="modal-info">{{ endDate }}</span></span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <span>SessionID : <span class="modal-info">{{ sessionID ?? '-' }}</span></span>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <span>Type : <span class="modal-info">{{type_options.find((e) => e.value == type).name
                        }}</span></span>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" sm="3" class="d-flex justify-center justify-sm-end">
              <button type="button" class="download-btn" @click="ExportFileQuestionSet()">
                <img src="@/assets/bxs_download.svg" alt="img" width="20" height="20" />
                <span style="color: #ffffff; font-size: 14px;">{{ $t('Download') }}</span>
              </button>
            </v-col>
          </v-row>

          <div class="d-flex justify-start align-center gap-2 mt-10">
            <img src="@/assets/streamline-logos_google-chat-logo-block.svg" alt="img" width="20" height="20">
            <p style="color: #171717; font-size: 18px; font-weight: 500;">Chat Log</p>
          </div>
          <v-card class="advanced-filter-card mt-6 pa-4">
            <v-row class="align-center">
              <v-col cols="10">
                <div class="d-flex justify-space-between align-center">
                  <label style="color: #171717; font-size: 14px;">{{ selectedOption !== null ? selectedOption : 'Select Question Set'}}</label>
                </div>
              </v-col>
              <v-col cols="2" class="d-flex justify-end">
                <button type="button" @click="showSelect = !showSelect" style="border: none;
                    border-radius: 50%; width: 32px; height: 32px; display: flex;
                    justify-content: center;align-items: center; cursor: pointer;">
                  <img src="@/assets/Add icon small.svg" alt="img" width="24" height="24" />
                </button>
              </v-col>
            </v-row>
            <hr>
            <div v-if="showSelect" class="dropdown-list">
              <div v-for="item in dropdownItems" :key="item.name" @click="handleSelectChange(item.name)"
                style="padding: 8px 16px; cursor: pointer; border-radius: 6px; font-size: 15px; color: #171717; margin-bottom: 2px; white-space: pre-line;"
                :style="selectedOption === item.name ? 'background: #f5f5f5;' : ''">
                {{ item.name }}
              </div>
            </div>
            <v-row class="align-center mt-6">
              <v-text-field v-if="isAddingData" v-model="QuestionSetName" class="ml-2 mr-2" label="Enter new data"
                density="compact" hide-details></v-text-field>
            </v-row>
            <v-row class="align-center mt-6">
              <v-col cols="10">
                <div class="d-flex justify-space-between align-center">
                  <label style="color: #171717; font-size: 14px;">{{ selectedOptionQSNameTxt !== null ?
                    selectedOptionQSNameTxt : 'Question Type'}}</label>
                </div>
              </v-col>
              <v-col cols="2" class="d-flex justify-end">
                <button type="button" @click="showSelectType = !showSelectType"
                  style="border: none; border-radius: 50%;
                    width: 32px; height: 32px; display: flex; justify-content: center; align-items: center; cursor: pointer;">
                  <img src="@/assets/Add icon small.svg" alt="img" width="24" height="24" />
                </button>
              </v-col>
            </v-row>
            <div style="margin-bottom: 12px;">
              <hr>
            </div>
            <div v-if="showSelectType"
              style="border-radius: 14px; margin-top: 10px; background: #fff; box-shadow: 0 2px 8px rgba(0,0,0,0.07);">
              <div v-for="item in dropdownItemsQSType" :key="item.name"
                @click="handleSelectChange1(item.value, item.name)"
                style="padding: 8px 16px; cursor: pointer; border-radius: 6px; font-size: 15px; color: #171717; margin-bottom: 2px; white-space: pre-line;"
                :style="selectedOptionQSName === item.name ? 'background: #f5f5f5;' : ''">
                {{ item.name }}
              </div>
            </div>
          </v-card>

        </v-card-text>
        <div class="mt-8">
          <hr />
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="category-dialog-footer">
            <button type="button" class="footer-btn cancel" @click="dialogExportQS = false">Cancel</button>
            <button type="button" class="footer-btn save" @click="ExportQuestionSet">
              <img src="@/assets/ic_round-plus.svg" alt="img" width="20" height="20" />
              <span style="color: #ffffff; font-size: 14px;">{{ $t("add") }}</span>
            </button>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import dateUtils from '../plugins/date-utils';
import moment from 'moment';
import checkPermissionTwo from '@/api/function.js';
import LogTrace from '@/api/function.js';
export default {
  name: 'LogMessage',
  inject: ["flagNav", "FontColorTitle", "SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    showSelect: false,
    showSelectType: false,
    isInitialized: false,
    selectedOption: null,
    selectedOptionQSName: null,
    selectedOptionQSNameTxt: null,
    QuestionSetName: '',
    dropdownItems: [],
    dropdownItemsQSType: [
      {
        name: 'Normal Question',
        value: 'P',
      },
      {
        name: 'Chain Question',
        value: 'C',
      },
    ],
    isAddingData: false,
    userChannel: null,
    sessionID: null,
    checkbox1: false,
    dialog: false,
    dialogExportQS: false,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    tableLoading: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },

    startDateFlag: false,
    endDateFlag: false,
    startDate: null,
    endDate: null,
    type: 'Token',

    detailsExpanded: false,
    DDModelShow: [],
    searchModelName: '',
    isSearch: false,
    isFirst: true,
    dataTable: [],
    type_options: [
      { value: 'Token', name: 'Token Usage' },
      { value: 'Chat', name: 'Chat Log' },
      { value: '', name: 'Raw Log' },
      { value: 'SQL', name: 'SQL Log' },
      { value: 'Intent', name: 'Intent Log' },
      { value: 'Error', name: 'Error Log' },
      { value: 'FD', name: 'Memory Debugger' },
    ],
    ShowAllText: false,
    CheckboxShowAllText: false,
  }),
  computed: {
    headers() {
      return [
        {
          title: this.$t('no'),
          align: 'left',
          width: '100px',
          sortable: false,
        },
        { title: 'Input Message', align: 'left', sortable: false, width: '500px', minWidth: '300px' },
        {
          title: 'Output Message',
          align: 'left',
          sortable: false,
          width: '500px',
          minWidth: '300px'
        },
        { title: 'System Message', align: 'left', sortable: false, width: '500px', minWidth: '300px' },
        { title: 'Knowledge', align: 'left', sortable: false, width: '500px' },
        { title: 'Logs ID', align: 'left', sortable: false, width: '500px' },
        { title: 'Session ID', align: 'left', sortable: false, width: '500px' },
        { title: this.$t('modelID'), align: 'left', sortable: false, width: '200px' },
        { title: this.$t('modelName'), align: 'left', sortable: false, width: '200px' },
        { title: 'User Channel', align: 'left', sortable: false, width: '80px' },
        { title: 'Create Date', align: 'left', sortable: false, width: '200px' },
        { title: 'Response Time (ms)', align: 'left', sortable: false, width: '80px' },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.Get();
      },
      deep: true,
    },
    CheckboxShowAllText(newVal) {
      let self = this;
      if (newVal) {
        self.ShowAll();
      } else {
        self.CloseShowAll();
      }
    },
  },
  methods: {
    formatDate(dateInput) {
      if (!dateInput) {
        return '';
      }
      if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const date = `${year}-${month}-${day}`;
      return date;
    },
    GetDDValidationPositive() {
      let self = this;
      if (self.dropdownItems != null && self.dropdownItems.length > 0) {
        return;
      }
      self.dialog = true;
      self.$call.GetValidationPositiveDD2(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.dropdownItems = dataResponse.data;
            self.dropdownItems.push({ name: 'New Question Set Name' });
          } else {
            self.dropdownItems = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    handleSelectChange(value) {
      this.selectedOption = value;
      if (value === 'New Question Set Name') {
        this.QuestionSetName = '';
        this.isAddingData = true; // แสดง Input Text
      } else {
        this.QuestionSetName = this.selectedOption;
        this.isAddingData = false; // ซ่อน Input Text
      }
    },
    handleSelectChange1(value, name) {
      this.selectedOptionQSName = value;
      this.selectedOptionQSNameTxt = name;
    },
    filterClick() {
      this.detailsExpanded = !this.detailsExpanded;
    },
    Refresh() {
      this.EditdialogUser = false;
      // window.location.reload();
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.Get();
    },
    Get() {
      let self = this;
      self.dialog = true;
      self.tableLoading = true;
      const { page, itemsPerPage } = this.options;

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        startDate: self.startDate,
        endDate: self.endDate,
        type: self.type,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
      };
      self.$call.GetTableLogMessage(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
            this.options.page = dataResponse.data.page;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
          self.dataTable.forEach((element) => {
            element.show = self.ShowAllText;
          });
          self.tableLoading = false;
        },
        (errorResource) => {
          self.tableLoading = false;
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetForDownload() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      const { page, itemsPerPage } = this.options;

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        startDate: self.startDate,
        endDate: self.endDate,
        type: self.type,
      };
      self.$call.GetTableLogMessage(
        temp,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            temp.page = 1;
            temp.perPage = 1;

            let array = [
              [
                '\ufeffID',
                '\ufeffTEXT',
                '\ufeffreplymsg',
                '\ufeffPrompt',
                '\ufeffshortmemory',
                '\ufeffTYPE_SEND',
                '\ufeffModel ID',
                '\ufeffModel name',
                '\ufeffUSER_CHANNEL',
                '\ufeffCreateDate',
                '\ufeffCreateBy',
                '\ufeffGUID',
                '\ufeffIsRead',
                '\ufeffPrompt_tokens',
                '\ufeffCompletion_tokens',
                '\ufeffTotal_tokens',
                '\ufeffModel',
                '\ufeffPollScore',
                '\ufeffintent',
                '\ufeffResponse_time(ms)',
              ],
            ];

            const total_max = dataResponse.data.total;
            let tasks = [];
            let i = 1;
            while (i <= total_max) {
              tasks.push(i);
              i++;
              // Simulate an asynchronous operation (e.g., API call) with a delay
              await new Promise((resolve) => setTimeout(resolve, 100));
            }
            // Ex. let tasks = [1,2,3,4,5,6,7,8,9,10];
            for (const index of tasks) {
              temp.page = index;
              await new Promise((resolve) => setTimeout(resolve, 100));
              await self.$call.GetTableLogMessage(temp, async (dataResponse) => {
                if (dataResponse.status == 0) {
                  let datas = dataResponse.data.data;
                  let conut = dataResponse.data.page;
                  // for (let index = 0; index < datas.length; index++) {
                  for (const data of datas) {
                    // const data = datas[index_1];
                    array.push([
                      data.id,
                      data.text,
                      data.replymsg,
                      data.prompt,
                      data.shortmemory,
                      data.typE_SEND,
                      data.modelDisplay,
                      data.modelName,
                      data.userChannel,
                      data.createDate,
                      data.createBy,
                      data.guid,
                      data.isRead,
                      data.prompt_tokens,
                      data.completion_tokens,
                      data.total_tokens,
                      data.model,
                      data.pollScore,
                      data.intent,
                      data.responseTimeStr,
                    ]);
                    await new Promise((resolve) => setTimeout(resolve, 100));

                    if (conut == total_max) {
                      let str = '';
                      for (const item of array) {
                        let line = '';
                        line = item.join(',');
                        str += line + '\r\n';
                      }
                      let blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });
                      let link = document.createElement('a');
                      let url = URL.createObjectURL(blob);
                      link.setAttribute('href', url);
                      link.setAttribute('download', `LogMessage_${self.convertDateToString(new Date(), '')}.csv`);
                      link.style.visibility = 'hidden';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      //
                      self.dialog = false;
                      self.isSearch = false;
                      self.isFirst = false;
                    }
                  }
                }
              });
            }
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );

      // let self = this;
      // self.dialog = true;
      // self.loading = true;

      // let temp = {
      //   startDate: self.startDate,
      //   endDate: self.endDate,
      //   type: self.type,
      // };
      // call.GetExportCSVLogMessage(
      //   temp,
      //   (dataResponse) => {
      //     if (dataResponse) {
      //       let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
      //       let fileLink = document.createElement("a");

      //       fileLink.href = fileURL;
      //       let fileName = `LogMessage_${self.convertDateToString(
      //         new Date(),
      //         ""
      //       )}.csv`;
      //       fileLink.setAttribute("download", fileName);
      //       document.body.appendChild(fileLink);

      //       fileLink.click();
      //     }
      //     self.dialog = false;
      //   },
      //   (errorResource) => {
      //     self.dialog = false;
      //     self.isSearch = false;
      //     console.error(errorResource);
      //   }
      // );
    },
    GetExportLogMonitoring() {
      let self = this;
      self.dialog = true;
      let req = {
        startDate: self.startDate,
        endDate: self.endDate,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
      };
      self.$call.GetExportLogMonitoring(
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `LogMonitoring__${self.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    ExportQuestionSet() {
      let self = this;
      self.dialog = true;
      if (
        self.selectedOption == null || self.selectedOptionQSName == null ||
        (
          (self.selectedOption == "New Question Set Name")
          && (self.QuestionSetName == null || self.QuestionSetName == undefined || self.QuestionSetName == "")
        )
      ) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningFillAll'),
          showConfirmButton: false,
          timer: 3000,
        });
        self.dialog = false;
        return;
      }
      else if (self.selectedOption == "New Question Set Name") {
        self.selectedOption = self.QuestionSetName;
      }
      let req = {
        startDate: self.startDate,
        endDate: self.endDate,
        // Name: self.QuestionSetName,
        Name: self.selectedOption,
        QuestionType: self.selectedOptionQSName,
        type: self.type == '' ? null : self.type,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
      };
      self.$call.ExportQuestionSet(
        req,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.dialogExportQS = false;
            self.selectedOption = null;
            self.selectedOptionQSName = null;
            self.QuestionSetName = '';
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetExportLog() {
      let self = this;
      self.dialog = true;
      let req = {
        startDate: self.startDate,
        endDate: self.endDate,
        type: self.type == '' ? null : self.type,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
      };
      self.$call.GetExportLog(
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `Log__${self.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    ExportFileQuestionSet() {
      let self = this;
      self.dialog = true;
      if (self.selectedOptionQSName == null) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: "Please select a Question Set Type.",
          showConfirmButton: false,
          timer: 3000,
        });
        self.dialog = false;
        return;
      }
      let req = {
        startDate: self.startDate,
        endDate: self.endDate,
        Name: self.QuestionSetName,
        QuestionType: self.selectedOptionQSName,
        type: self.type == '' ? null : self.type,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
      };
      self.$call.ExportFileQuestionSet(
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `LogExportQuestionSet__${self.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },

    convertDateToString(date, seperator = '/') {
      return dateUtils.getStringWithTimeFromDate(moment(date).toDate(), seperator);
    },
    convertDateToString2(date, seperator = '-') {
      return dateUtils.getStringFromDatePickFormatDatePick2(moment(date).toDate(), seperator);
    },
    download() {
      const data = [];
      data.push('no,Text,Reply message,Prompt,Model Id,Model name,User channel,Create date\n');

      const a = document.createElement('a');
      let blob = new Blob(data, { type: 'data:text/csv;charset=BOM_UTF8' });
      const url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = 'upload_vector.csv';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
    substringLong(value) {
      if (value == null) {
        return '-';
      }
      if (value.length > 4000) {
        return value.substring(0, 3999) + '.....';
      }
      return value;
    },
    ShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTable.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    CloseShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTable.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
  },
  mounted() {
    this.GetDate();
    this.startDate = this.convertDateToString2(new Date());
    this.endDate = this.convertDateToString2(new Date());
    this.Get();
    this.isInitialized = true;
  },
};
</script>
<style scoped>
/* =============================================================================
   CARD COMPONENTS
   ============================================================================= */

.heading-text {
  color: #171717;
  font-weight: 600;
}

hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}

.card2 {
  border: 1px solid rgba(201, 201, 201, 1) !important;
  border-radius: 10px !important;
  box-shadow: none;
  padding: 10px;
}

.card-title {
  color: #171717;
  font-weight: 600;
  font-size: 14px;
}

.date-style {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  height: 40px;
}

.logType-select-input {
  background: white;
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  height: 40px;
}

.logType-select-input :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
}

.logType-select-input :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}

.logType-select-input :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}

.search-divider {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.search-btn {
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  height: 36px;
  width: 36px;
  border-radius: 18px;
  margin-left: -8px;
}

.action-divider {
  width: 2px;
  height: 60px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 1px;
  transition: background-color 0.2s ease;
  margin-top: 16px;
}

.advance-filters {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 24px;
}

/* v-switch */
.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important;
  /* off state */
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}

.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #FFFFFF !important;
}

/* Active (on) state */
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #FFFFFF !important;
  border: 1px solid #C32E0E !important;

}

.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #C32E0E !important;
  margin-right: 8px !important;
}

.memory-switch :deep(.v-switch__loader) {
  display: none !important;
}

.v-input--density-default {
  --v-input-control-height: none;
}

.date-divider-style {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
}

.date-divider {
  color: #c9c9c9;
  font-weight: 700;
  margin-top: 37px;
  margin-left: 20px;
}

.clear-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 28px;
  gap: 8px;
  padding: 9px;
  border-radius: 10px;
}

.clear-button:hover {
  background: rgba(56, 89, 208, 0.1);
  border-radius: 10px;
}

.filter-by {
  color: #3859D0;
  font-size: 13px;
}

.action-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -6px;
}

:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}

.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}

.table-bottom-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.download-list-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 10px;
}

.download-list-item:hover {
  background: #CDD5F3;
}

.question-dialog {
  border-radius: 12px !important;
  background: #FFFFFF;
}

.question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 20px;
}

.question-title {
  font-size: 16px;
  font-weight: 600;
  color: #171717;
}

.category-dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  padding: 8px;
}

.footer-btn {
  border-radius: 12px;
  padding: 10px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  gap: 10px;
}

.footer-btn.cancel {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #949AA8;
  background: #ffffff;
  color: #646464;
  width: 72px;
}

.footer-btn.cancel:hover {
  background: #ebebef;
}

.footer-btn.save {
  display: flex;
  align-items: center;
  justify-content: center !important;
  gap: 8px;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  width: 100px;
}

.footer-btn.save span {
  color: #FFFFFF;
}

.date-card,
.filter-card,
.toggle-card {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.date-card:hover,
.filter-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}

.toggle-card {
  background: rgba(25, 118, 210, 0.05) !important;
}

.action-card {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.02), rgba(25, 118, 210, 0.05)) !important;
  border: 1px solid rgba(25, 118, 210, 0.2) !important;
}

.advanced-filter-card {
  background: rgba(239, 244, 255, 0.5) !important;
  border-radius: 16px;
  box-shadow: none;
}

.data-table-card {
  border: 1px solid #c9c9c9;
  border-radius: 12px !important;
  overflow: hidden;
}

/* =============================================================================
   FORM ELEMENTS
   ============================================================================= */
.date-field .v-field {
  border-radius: 8px !important;
}

.section-title {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
  border-bottom: 2px solid rgba(25, 118, 210, 0.2);
  padding-bottom: 8px;
}

/* =============================================================================
   BUTTONS
   ============================================================================= */
.download-btn {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 10px;
  width: 120px;
  justify-content: center;
  align-items: center;
  padding: 9px;
  gap: 6px;
}

.download-btn:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}

.download-menu {
  width: 226px;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  padding: 12px;
}

/* =============================================================================
   FILTER PANEL
   ============================================================================= */
.filter-panel-title {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.05), rgba(25, 118, 210, 0.1)) !important;
  border-radius: 8px 8px 0 0 !important;
}

/* =============================================================================
   DATA TABLE
   ============================================================================= */
.table-container {
  overflow-x: auto;
  max-width: 20%;
  scrollbar-width: thin;
  scrollbar-color: #C9C9C9;
}

.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: rgba(25, 118, 210, 0.5);
}

.modern-table {
  border-radius: 0 0 12px 12px !important;
  min-width: 1200px;
}

.modern-table :deep(.v-data-table__th) {
  white-space: nowrap;
  min-width: 120px;
}

.modern-table :deep(.v-data-table__td) {
  min-width: 120px;
  max-width: 200px;
}

.table-row {
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
}

/* =============================================================================
   TEXT CONTENT
   ============================================================================= */
.text-container {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 100px;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
  line-height: 1.4;
  word-break: break-word;
}

.text-content-show {
  white-space: pre-wrap;
  word-break: break-word;
  flex-grow: 1;
  line-height: 1.4;
  max-width: 300px;
}

/* =============================================================================
   LAYOUT
   ============================================================================= */
.action-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* =============================================================================
   ANIMATIONS
   ============================================================================= */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 960px) {
  .action-group {
    flex-direction: column;
    width: 100%;
  }

  .d-flex.justify-space-between {
    flex-direction: column !important;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .modern-table {
    min-width: 800px;
  }

  .modern-table :deep(.v-data-table__th),
  .modern-table :deep(.v-data-table__td) {
    min-width: 100px;
    max-width: 150px;
  }

  .date-card,
  .filter-card,
  .toggle-card {
    margin-bottom: 12px;
  }
}

@media (max-width: 600px) {
  .section-title {
    font-size: 1rem;
  }

  .filter-section {
    margin-bottom: 24px;
  }
}

.dropdown-list {
  border-radius: 14px;
  margin-top: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  max-height: 200px;
  overflow-y: auto;

  /* Custom scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: #C32E0E #f5f5f5;
}

/* Webkit browsers (Chrome, Safari, Edge) */
.dropdown-list::-webkit-scrollbar {
  width: 6px;
}

.dropdown-list::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 10px;
}

.dropdown-list::-webkit-scrollbar-thumb {
  background: #C32E0E;
  border-radius: 10px;
}

.dropdown-list::-webkit-scrollbar-thumb:hover {
  background: #F67760;
}

.dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 6px;
  font-size: 15px;
  color: #171717;
  margin-bottom: 2px;
  white-space: pre-line;
  transition: background 0.2s ease;
}

.dropdown-item:hover {
  background: #f9f9f9;
}

.dropdown-item-active {
  background: #f5f5f5;
}
</style>
